import { Feedback } from './feedback.interface';

export interface FeedbackChallenge {
  name_challenge: string;
  number_challenge: number;
  activities: FeedbackActivity[];
}

export interface FeedbackActivity {
  name_activity: string;
  number_activity: number;
  feedbackActivity: Feedback;
}
